<template>
	<div class="text-center">
		<span v-if="value" class="m-badge m-badge--success"></span>
		<span v-else class="m-badge m-badge--secondary" ></span>
	</div>
</template>
<script>
export default {
    props: ['value']
};
</script>



// WEBPACK FOOTER //
// resources/js/metronic/table/value/BooleanColorDot.vue